// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a5b7410b","845":"2362d703"}[chunkId] + ".chunk.js";
};